import { IconCalendarTime, IconReload } from '@tabler/icons-react';
import moment from 'moment';
import React from 'react';
import { Calendar } from 'react-date-range';
import KaratCheckboxDropdown from './KaratCheckboxDropdown';

function SmTransaksiTertunda({
  summaryPenjualan = [],
  loadingDataPenjualan,
  cabangFilterSm = [],
  setIdCabangFilterPenjualan,
  setDateFilterPenjualan,
  reloadPenjualan,
  totalHargaPenjualan,
  totalBeratPenjualan,
  totalBijiPenjualan,
  setKaratFilterPenjualan,
  idCabangFilterPenjualan,
  karatFilterPenjualan,
  dateFilterPenjualan,
}) {
  function numberWithCommas(x) {
    if (x === undefined || x === null) return '0';
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function handleSelect(date) {
    setDateFilterPenjualan(moment(date).format('DD-MM-YYYY'));
  }

  const average = Math.round(totalHargaPenjualan / totalBeratPenjualan);
  const isOwner = localStorage.getItem('role') === 'owner';

  return (
    <div className="bg-white dark:bg-slate-800">
      <div className="px-3 md:px-4 py-2 flex flex-col md:flex-row md:items-center justify-between bg-purple-500/50 dark:bg-purple-600/20 gap-3 border-b border-purple-600/10 dark:border-purple-500/20">
        <h6 className="font-bold uppercase text-sm text-slate-900 dark:text-slate-100">Penggarus</h6>
        <div className="flex flex-nowrap items-center gap-2">
          {isOwner ? (
            <span className="text-[11px] font-bold px-2 py-1 rounded-lg bg-purple-500/10 text-purple-600 dark:text-purple-400 border border-purple-500/20">
              Pusat
            </span>
          ) : (
            <div className="flex items-center gap-1.5 bg-white dark:bg-slate-800 px-2 py-1 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm">
              <span className="text-[10px] font-bold text-slate-400 uppercase">Etalase:</span>
              <select
                className="cursor-pointer text-xs font-bold bg-transparent text-slate-700 dark:text-slate-200 outline-none"
                value={idCabangFilterPenjualan}
                onChange={(e) => setIdCabangFilterPenjualan(e.target.value)}
              >
                <option value="" className="dark:bg-slate-800">Semua</option>
                {cabangFilterSm
                  .filter((cbf) => !cbf.nama_cabang?.toLowerCase().includes('brankas'))
                  .map((cbf) => (
                    <option key={cbf.id} value={cbf.id} className="dark:bg-slate-800">
                      {cbf.nama_cabang}
                    </option>
                  ))}
              </select>
            </div>
          )}

          <KaratCheckboxDropdown
            selectedKarat={karatFilterPenjualan}
            onChange={setKaratFilterPenjualan}
          />

          <div className="dropdown dropdown-bottom dropdown-end sm:dropdown-start flex-shrink-0">
            <div tabIndex={0} className="bg-orange-500 hover:bg-orange-600 transition-colors text-white p-1.5 rounded-lg cursor-pointer flex items-center gap-2 shadow-sm">
              <IconCalendarTime size={18} />
              {dateFilterPenjualan && <span className="text-xs font-bold">{dateFilterPenjualan}</span>}
            </div>
            <div tabIndex={0} className="dropdown-content menu p-2 z-50 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-200 dark:border-slate-700">
              <Calendar
                size={20}
                onChange={handleSelect}
                date={dateFilterPenjualan ? moment(dateFilterPenjualan, 'DD-MM-YYYY').toDate() : new Date()}
                className="bg-white dark:bg-slate-800 rounded-lg shadow-xl border border-slate-200 dark:border-slate-700 overflow-hidden"
              />
            </div>
          </div>

          <button
            onClick={reloadPenjualan}
            title="Muat ulang"
            className="text-white p-1.5 rounded-lg bg-orange-500 hover:bg-orange-600 transition-colors flex-shrink-0 shadow-sm"
          >
            <IconReload size={18} />
          </button>
        </div>
      </div>

      <div className="p-2 overflow-x-auto">
        {loadingDataPenjualan ? (
          <div className="font-semibold px-2 py-1 rounded-br-md rounded-bl-md flex items-center gap-3 text-slate-600 dark:text-slate-300">
            <svg width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <style
                dangerouslySetInnerHTML={{
                  __html:
                    '.spinner_Wezc{transform-origin:center;animation:spinner_Oiah .75s step-end infinite}@keyframes spinner_Oiah{8.3%{transform:rotate(30deg)}16.6%{transform:rotate(60deg)}25%{transform:rotate(90deg)}33.3%{transform:rotate(120deg)}41.6%{transform:rotate(150deg)}50%{transform:rotate(180deg)}58.3%{transform:rotate(210deg)}66.6%{transform:rotate(240deg)}75%{transform:rotate(270deg)}83.3%{transform:rotate(300deg)}91.6%{transform:rotate(330deg)}100%{transform:rotate(360deg)}}',
                }}
              />
              <g className="spinner_Wezc">
                <circle cx={12} cy="2.5" r="1.5" opacity=".14" />
                <circle cx="16.75" cy="3.77" r="1.5" opacity=".29" />
                <circle cx="20.23" cy="7.25" r="1.5" opacity=".43" />
                <circle cx="21.50" cy={12.0} r="1.5" opacity=".57" />
                <circle cx="20.23" cy="16.75" r="1.5" opacity=".71" />
                <circle cx="16.75" cy="20.23" r="1.5" opacity=".86" />
                <circle cx={12} cy="21.5" r="1.5" />
              </g>
            </svg>
            Memuat data....
          </div>
        ) : (
          <table className="w-full border dark:border-slate-700 text-sm text-left rounded-md overflow-hidden">
            <thead className="text-xs sticky top-0 border-b dark:border-slate-700 uppercase bg-gray-50 dark:bg-slate-700/50 text-slate-700 dark:text-slate-200">
              <tr>
                <th>No</th>
                <th>Kategori</th>
                <th>PCS</th>
                <th>Berat</th>
                <th>Harga</th>
                <th>Rata - Rata</th>
              </tr>
            </thead>
            <tbody>
              {summaryPenjualan.map((sp, i) => {
                const rata_rata = Math.round(sp.total_harga_penjualan / sp.total_berat_penjualan);
                return (
                  <tr
                    key={i}
                    className="border-b dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700/30 transition-colors text-slate-600 dark:text-slate-300"
                  >
                    <td className="dark:text-slate-100 font-bold px-0 py-0">{i + 1}.</td>
                    <td className="dark:text-slate-100 font-bold px-0 py-0">{sp.kategori}</td>
                    <td className="dark:text-slate-100 font-bold px-0 py-0">{sp.jumlah_item_penjualan}</td>
                    <td className="dark:text-slate-100 font-bold px-0 py-0">{sp.total_berat_penjualan}</td>
                    <td className="dark:text-slate-100 font-bold px-0 py-0">
                      Rp {numberWithCommas(sp.total_harga_penjualan === undefined ? '0' : sp.total_harga_penjualan)}
                    </td>
                    <td className="dark:text-slate-100 font-bold px-0 py-0">
                      Rp {numberWithCommas(isNaN(rata_rata) ? 0 : rata_rata)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}

        <div className="font-bold mt-2 border dark:border-slate-700 text-sm rounded-md p-1 bg-slate-50/50 dark:bg-slate-800/50 overflow-x-auto scrollbar-none flex items-center text-slate-700 dark:text-slate-200">
          <div className="whitespace-nowrap">
            [ <span className="text-red-600 dark:text-red-400">{totalBijiPenjualan}</span> pcs ]&nbsp;
          </div>
          <div className="whitespace-nowrap ml-3">
            [ <span className="text-red-600 dark:text-red-400">{totalBeratPenjualan}</span> gr ]&nbsp;
          </div>
          <div className="whitespace-nowrap ml-3">
            [{' '}
            <span className="text-red-500 dark:text-red-400">
              Rp.{numberWithCommas(totalHargaPenjualan === undefined ? '0' : totalHargaPenjualan)}
            </span>
            ]&nbsp;
          </div>
          <div className="whitespace-nowrap ml-3 text-slate-600 dark:text-slate-100">
            [ rata-rata{' '}
            <span className="text-red-500 dark:text-red-400">
              Rp.{numberWithCommas(isNaN(average) ? 0 : average)}
            </span>{' '}
            ]
          </div>
        </div>
      </div>
    </div>
  );
}

export default SmTransaksiTertunda;
